    <div class="modal-header">
      <h4 class="modal-title">Add New Reward</h4>
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

    <form class="form-horizontal" [formGroup]="rewardForm" (ngSubmit)="onSubmit()">
        <div class="row col-sm-12" style="margin-top: 20px">
            <ngb-alert *ngIf="responseMessage" [type]="messageType" (close)="responseMessage = null">{{ responseMessage }}</ngb-alert>   
        </div>
        <div class="form-group">
            <label class="col-md-8 col-form-label">Reward Value <span>(What winners get)</span>:</label>
            <div class="col-md-12">
                <input type="text"  class="form-control" fullWidth formControlName="reward_value" required="true">
            </div>
        </div> 
        <div class="form-group">
            <label class="col-md-8 col-form-label">Reward Type <span>(Type of reward)</span>:</label>
            <div class="col-md-12">
                <select class="custom-select mt-3" formControlName="reward_type">
                    <option>iPhone</option>
                    <option>T-Shirt</option>
                    <option>Bumper Packs</option>
                    <option>Airtime</option>
                </select>               
            </div>
        </div>  
        <div class="form-group">
            <label class="col-md-8 col-form-label">Reward Point <span>(Points required to get the gift)</span>:</label>
            <div class="col-md-12">
                <input type="number" class="form-control" formControlName="reward_point" required="true">
            </div>
        </div> 
        <div class="form-group">
            <label class="col-md-8 col-form-label">Reward Quantity <span>(The quantity of the reward)</span>:</label>
            <div class="col-md-12">
                <input type="number" class="form-control" formControlName="reward_quant" required="true">
            </div>
        </div> 
        <div class="form-group">
            <label class="col-md-8 col-form-label">Image:</label>
            <div class="col-md-12">
                <input type="file" class="form-control"  (change)="onFileChange($event)" accept="image/*" required="true">
            </div>
        </div> 
        </form>
    </div>
    <!-- <div class="modal-body">
        <div class="form-group">
            <label class="col-md-12 col-form-label">How Frequently Should This Reward Be Shown To Users?</label>
            <div class="col-md-12">
                <select class="custom-select mt-3" formControlName="survey_rewardId">
                    <option>me</option>
                    <option>me</option>
                    <option>me</option>
                </select>
            </div>
        </div> 
    </div> -->
    <div class="modal-footer">
      <button type="button" [disabled]="processing" class="btn btn-success btn-q" (click)="onSubmit()">
        <img *ngIf="processing" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          Save & Submit
        </button>
    </div>

 